var render = function render(){var _vm=this,_c=_vm._self._c;return _c('highcharts',{ref:"chart",staticClass:"chart",style:({ width: '100%', height: '100%' }),attrs:{"options":_vm.chartOptions,"isResizeble":_vm.isResizeble}})
}
var staticRenderFns = []

export { render, staticRenderFns }